import type { Store } from 'redux';

import { createHttpRequest } from 'ovpn-ui-toolkit';

import { authRoutines } from '../auth';
import { mapToLegacyErrorCode } from '../constants/errorCodes';
import { getTenant } from '../utils/cloudLocationUtils';
import { getEnvVar } from '../utils/getEnvVar';

let cachedStore: Store | null = null;

export function setupRequestInterceptor(store: Store) {
    cachedStore = store;
}

export const RequestBadResponseActionType = 'REQUEST_BAD_RESPONSE';
export const requestBadResponseAction = (payload: unknown) => ({
    type: RequestBadResponseActionType,
    payload,
});

function onSuccess() {
    if (cachedStore === null) {
        console.warn('Api Client: store not set. onSuccess action is ignored');
        return;
    }

    cachedStore.dispatch(authRoutines.setAuthToken());
}

function onError(response: Response) {
    if (cachedStore === null) {
        console.warn('Api Client: store not set. Error action is ignored', { response });
        return;
    }

    cachedStore.dispatch(requestBadResponseAction({ status: response.status, response }));
}

function onUnauthorized() {
    if (cachedStore === null) {
        console.warn('Api Client: store not set. Unauthorized action is ignored');
        return;
    }

    cachedStore.dispatch(authRoutines.unauthorized());
}

function makeApiGateway(gate: string) {
    const headers: Record<string, string> = { 'x-tenant': getTenant() };

    return createHttpRequest({
        apiBase: `${window.location.protocol}//${window.location.host}${gate}`,
        options: { headers },

        onError,
        onSuccess,
        onUnauthorized,

        mapErrorCode: mapToLegacyErrorCode,
    });
}

export const accessApi = makeApiGateway('/access-gate/api/v1');
export const networkApi = makeApiGateway('/network-gate/api/v1');
export const settingsApi = makeApiGateway('/settings-gate/api/v1');
export const userManagementApi = makeApiGateway('/user-gate/api/v1');

export const ssoApi = createHttpRequest({
    apiBase: `${getEnvVar('SSO_API_HOST')}/sso/api/v1`,
    onError,
    onUnauthorized,
    onSuccess: () => {
        if (cachedStore === null) {
            console.warn('Api SSO Client: store not set. onSuccess action is ignored');
            return;
        }

        cachedStore.dispatch(authRoutines.getProductToken());
    },
});
